export default __webpack_public_path__ + "static/media/yakhmarscave.3e5df50a.jpg";